import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import formset from '../../versa/formset.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/integration-events.js';
import form from '../forms/integration-events.js';
import techhubPullForm from '../forms/integration-events-techhub-pull.js';
import * as types from '../types.js';

const integrationEvents = function()
{

	let integration_events_crud = crud.create({
		async loadBaseData()
		{
			await Promise.all([
				api.call(api.list_users, this.queryAll()).then((data) => db.set('users', data)).catch(error => notify(error)),
				api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data)).catch(error => notify(error)),
			]);
		},
		async queryData(query)
		{
			return await api.call(api.list_integration_events, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_integration_event, id);
			_record.request_payload = _record.request_payload ? JSON.stringify(_record.request_payload, null, 2) : '';
			_record.response_payload = _record.response_payload ? JSON.stringify(_record.response_payload, null, 2) : '';
			return _record;
		},
		async saveRecord()
		{
		},
		techhubProcessQueue()
		{
			const run = async () =>
			{
				const data = await api.call(api.post_integration_events_techhub_process, 200);
				if (data) {
					let msg = `Fila TechHub: retirados ${data.picked ?? '—'}, ok ${data.success ?? 0}, parcial ${data.partial ?? 0}, falha ${data.failure ?? 0}.`;
					const sample = data.errors_sample && data.errors_sample[0];
					if (sample && sample.error)
						msg += ` Ex.: inbox ${sample.inbox_id}: ${String(sample.error).slice(0, 280)}`;
					notify(msg, 'Resultado');
				}
				this.loadPage();
			};
			ask(
				'Processar até 200 itens pendentes na fila TechHub (inbox)? Em produção isso costuma rodar por cron no servidor; em QA use esta ação para validar com o cliente.',
				'Confirmação',
				(answer) => { if (answer === 'Y') run(); },
			);
		},
		techhubFlushStatus()
		{
			const run = async () =>
			{
				const data = await api.call(api.post_integration_events_techhub_flush_status, 200);
				if (data)
					notify(`Status IBL: retirados ${data.picked ?? '—'}, enviados ${data.sent ?? 0}, falha ${data.failure ?? 0}.`, 'Resultado');
				this.loadPage();
			};
			ask(
				'Enviar até 200 atualizações de status pendentes para a API da IBL?',
				'Confirmação',
				(answer) => { if (answer === 'Y') run(); },
			);
		},
		techhubPullBulk()
		{
			const run = async () =>
			{
				const data = await api.call(api.post_integration_events_techhub_pull, {});
				if (data)
				{
					const nerr = (data.errors && data.errors.length) ? data.errors.length : 0;
					notify(
						`Pull (mapeamentos): ${data.targets ?? '—'} local(is), ${data.total_fetched ?? 0} fatura(s) na API, ${data.total_enqueued ?? 0} na fila.${nerr ? ` Erros em ${nerr} local(is).` : ''}`,
						'Resultado',
					);
				}
				this.loadPage();
			};
			ask(
				'Consultar a IBL (GET /faturas/integrado) para cada mapeamento ativo das suas empresas e enfileirar na inbox?',
				'Confirmação',
				(answer) => { if (answer === 'Y') run(); },
			);
		},
		techhubPullSingle()
		{
			let fs;
			const submit = async (data) =>
			{
				const company_id = String(data.tp_company_id || '').trim();
				const raw = data.tp_cd_local_origem;
				const cd_local_origem = parseInt(String(raw !== undefined && raw !== null ? raw : '').trim(), 10);
				if (!company_id || Number.isNaN(cd_local_origem))
				{
					notify('Informe empresa (UUID) e cd_local_origem (número, ex.: 3006).', 'Atenção');
					return;
				}
				const out = await api.call(api.post_integration_events_techhub_pull, { company_id, cd_local_origem });
				if (out && out.mode === 'single' && out.result)
					notify(`Pull: ${out.result.fetched} fatura(s) lida(s), ${out.result.enqueued} na fila.`, 'Resultado');
				else if (out)
					notify('Pull concluído.', 'Resultado');
				fs.destroy();
				this.loadPage();
			};
			db.list('companies').then((rows) =>
			{
				fs = formset.create(techhubPullForm, submit);
				fs.init();
				const dl = fs.dialog.getNode().querySelector('#techhub_pull_companies');
				if (dl)
				{
					dl.innerHTML = (rows || []).map((c) =>
					{
						const id = String(c.id || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
						const lab = String(c.nick || c.name || c.id || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
						return `<option value="${id}" label="${lab}"></option>`;
					}).join('');
				}
			}).catch((e) => notify(e.message || String(e), 'Falha'));
		},
	});

	// Índices = ordem do SELECT leve em repos/integration_events (SQL_BASE_SELECT_LIGHT)
	let fieldspecs = [
		{ index: 1, field: 'id', label: 'Evento', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador' },
		{ index: 2, field: 'date_time', label: 'Data/Hora', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora' },
		{ index: 3, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 4, field: 'integration_key', label: 'Integração', types: [], placeholder: '', title: 'Chave da integração' },
		{ index: 5, field: 'direction', label: 'Direção', types: [], placeholder: '', title: 'inbound / outbound' },
		{ index: 6, field: 'status', label: 'Status', types: [], placeholder: '', title: 'success / failure / partial' },
		{ index: 7, field: 'summary', label: 'Resumo', types: [], placeholder: '', title: 'Resumo' },
		{ index: 8, field: 'entity_type', label: 'Tipo entidade', types: [], placeholder: '', title: 'Tipo da entidade' },
		{ index: 9, field: 'entity_id', label: 'ID entidade', types: [], placeholder: '', title: 'Identificador da entidade' },
		{ index: 10, field: 'error_message', label: 'Erro', types: [], placeholder: '', title: 'Mensagem de erro' },
		{ index: 11, field: 'correlation_id', label: 'Correlação', types: [], placeholder: '', title: 'UUID de correlação' },
		{ index: 12, field: 'source', label: 'Origem', types: [], placeholder: '', title: 'Origem do registro' },
		{ index: 13, field: 'recorded_by', label: 'Registrado por', types: [types.datalist()], placeholder: '', title: 'Usuário', store: 'users', labels: ['name'] },
	];

	integration_events_crud.run(
		'integration_events',
		'Eventos de integração',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		[
			{ hash: '#techhub-pull-bulk', label: 'Buscar faturas na IBL (mapeamentos)' },
			{ hash: '#techhub-pull-single', label: 'Buscar faturas (empresa e local)' },
			{ hash: '#techhub-process', label: 'Processar fila TechHub' },
			{ hash: '#techhub-flush-status', label: 'Enviar status à IBL' },
		],
		[],
	);

	router.set('#techhub-pull-bulk', integration_events_crud.techhubPullBulk.bind(integration_events_crud));
	router.set('#techhub-pull-single', integration_events_crud.techhubPullSingle.bind(integration_events_crud));
	router.set('#techhub-process', integration_events_crud.techhubProcessQueue.bind(integration_events_crud));
	router.set('#techhub-flush-status', integration_events_crud.techhubFlushStatus.bind(integration_events_crud));

};

export default integrationEvents;
